import styled from '@emotion/styled';
import { borderRadii } from '__app/spacing';
import Input from '__components/Kizen/Input';
import TableScrollContainer from '__components/Tables/ScrollContainer';

export const StyledPage = styled.section`
  margin: 20px 0;
`;

export const StyledPageWrapper = styled.div`
  margin: 20px 0 0;
`;

export const StyledTableToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  margin-bottom: 20px;
`;

export const StyledSearchInput = styled(Input)`
  max-width: 200px;

  label {
    margin: 0;
  }

  .input-wrapper {
    margin: 0;
    background-color: var(--color-background-white);
  }

  input {
    min-width: 0;
    padding-right: 0;
  }
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  flex: 1;
  background-color: var(--color-background-white);
  border-radius: ${borderRadii.small};
  overflow-y: hidden;
  flex-direction: column;
  position: relative;
  height: 100%;
  > div {
    position: relative;
    height: 100%;
  }
`;

export const StyledPaginationWrapper = styled.div`
  width: 100%;
  flex: 0 0 45px;
  padding-top: 20px;
`;

export const StyledTableScrollContainer = styled(TableScrollContainer)`
  height: 100%;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const StyledModalBody = styled.div`
  text-align: start;
`;

export const StyledDetails = styled.pre`
  font-family: 'Courier New', Monospace;
  font-size: 12px;
  white-space: pre-wrap;
  line-height: 1.5;
  background-color: var(--color-background-default);
  padding: 10px;
  border-radius: ${borderRadii.small};
  margin: 0;
`;

export const StyledConnectSteps = styled.ol`
  margin: 0;
  padding-left: 18px;

  li {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
